import React, { FC } from "react";
import { SVGProps } from '@utils';
import { SvgWrapper } from "./SvgWrapper";

export const BlueArrowDown: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.8553 9L0 1.36749L1.40741 0L7.8553 6.26502L14.3032 0L15.7106 1.36749L7.8553 9Z" fill="#3273E1"/>
    </svg>
  </SvgWrapper>
);
